import { useEffect } from "react";

/**
 * Posts the document height to the parent window via postMessage
 * whenever the body resizes. Only runs when inside an iframe.
 *
 * Parent page should listen for { type: "zavy-resize", height } messages
 * and set the iframe height accordingly.
 */
export default function useIframeResize() {
	useEffect(() => {
		// Only run if we're inside an iframe
		if (window.self === window.top) return;

		const postHeight = () => {
			const height = document.documentElement.scrollHeight;
			window.parent.postMessage({ type: "zavy-resize", height }, "*");
		};

		const observer = new ResizeObserver(postHeight);
		observer.observe(document.body);

		// Fire on initial load
		postHeight();

		return () => observer.disconnect();
	}, []);
}
